(function() {
  exports.Column = (function() {
    function Column() {
      this.id = null;
      this.display_name = '';
      this.class_name = '';
      this.is_editable = true;
      this.validation_rules = [];
      this.completion_rules = [];
      this.input_type = '';
      this.has_static_options = false;
      this.options_alias = null;
      this.column_alias = '';
    }

    return Column;

  })();

}).call(this);
